import { Injectable } from '@angular/core';
import { SelectionServiceBase } from './selection-base';
import { Customer } from './customer';
import { CartService } from './cart';
import { StorageMap } from '@ngx-pwa/local-storage';

@Injectable({ providedIn: 'root' })
export class CustomerSelectionService extends SelectionServiceBase<Customer> {
  constructor(private cartService: CartService, storage: StorageMap) {
    super(storage, 'selectedCustomer');
  }

  override setSelected(value: Customer, storeValue: boolean = false): void {
    if (this.getSelected()?.id !== value.id) {
      super.setSelected(value, storeValue);

      // 🧹 Clear cart when customer changes
      this.cartService.clearCart().catch(err => {
        console.warn('Failed to clear cart on customer change:', err);
      });
    }
  }

  override clearSelected(): void {
    super.clearSelected();

    // 🧹 Clear cart when customer is cleared
    this.cartService.clearCart().catch(err => {
      console.warn('Failed to clear cart on customer clear:', err);
    });
  }
}
